import LoginForm from './LoginForm'
import ForgotPasswordForm from './ForgotPasswordForm'
import ResetPasswordForm from './ResetPasswordForm'
import UpdatePasswordForm from './UpdatePasswordForm'

export default {
  LoginForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  UpdatePasswordForm
}
